import React, { useState, useEffect } from 'react';
import { MdWarning, MdMoneyOff, MdHistory, MdClose, MdCampaign, MdCheckCircle } from 'react-icons/md';
import api from '../api/axios';

export default function PenaltyCard() {
    const [data, setData] = useState({ total_amount: 0, details: [] });
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);

    // Admin Remark State
    const [adminRemark, setAdminRemark] = useState(null);
    const [inspectionId, setInspectionId] = useState(null);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            // Fetch Penalties
            const penRes = await api.get('/penalties/my');
            setData(penRes.data);


        } catch (error) {
            console.error("Failed to fetch data", error);
        } finally {
            setLoading(false);
        }
    };

    const dismissRemark = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!inspectionId) return;

        try {
            await api.delete(`/inspections/${inspectionId}/admin-remarks`);
            setAdminRemark(null); // Clear locally
        } catch (error) {
            console.error("Failed to dismiss", error);
        }
    };

    if (loading) return null;

    const hasPenalty = data.total_amount > 0;

    return (
        <>
            <div
                className={`relative z-10 rounded-2xl p-6 text-white shadow-lg overflow-hidden transition-all transform hover:scale-[1.02] ${hasPenalty
                    ? 'bg-gradient-to-br from-red-500 to-rose-600'
                    : 'bg-gradient-to-br from-green-500 to-emerald-600'
                    }`}
                onClick={(e) => {
                    // Only open modal if NOT clicking the dismiss button
                    e.preventDefault();
                    setShowModal(true);
                }}
                role="button"
                tabIndex={0}
            >
                <div className="absolute top-0 right-0 p-2 animate-pulse">
                    {hasPenalty && <div className="w-3 h-3 bg-white rounded-full"></div>}
                </div>

                {hasPenalty ? (
                    <MdWarning className="absolute -bottom-4 -right-4 text-red-900 opacity-20" size={120} />
                ) : (
                    <MdMoneyOff className="absolute -bottom-4 -right-4 text-green-400 opacity-30" size={100} />
                )}

                <h3 className="text-lg font-bold opacity-90 flex items-center gap-2">
                    {hasPenalty ? <><MdWarning className="text-yellow-300" /> Penalty Active</> : "Inspection Status"}
                </h3>

                <div className="mt-3">
                    <span className="text-4xl font-extrabold">₹{data.total_amount}</span>
                    <span className="text-sm font-medium opacity-80 ml-2">{hasPenalty ? "Total Fine" : "Outstanding"}</span>
                </div>

                <p className="mt-3 text-sm font-medium bg-black/20 inline-block px-3 py-1 rounded-lg">
                    {hasPenalty ? `${data.details.length} Days Missed. Tap for details.` : "Excellent! No active penalties. Tap for history."}
                </p>

                {/* Admin Remark Section - Integrates INSIDE the card */}
                {/* Admin Remark Section - Integrates INSIDE the card */}

            </div>

            {/* Common Modal for Both States */}
            {showModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4" onClick={() => setShowModal(false)}>
                    <div className="bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden" onClick={e => e.stopPropagation()}>
                        <div className={`p-4 border-b flex justify-between items-center ${hasPenalty ? 'bg-red-50 border-red-100' : 'bg-green-50 border-green-100'}`}>
                            <h3 className={`text-lg font-bold flex items-center gap-2 ${hasPenalty ? 'text-red-800' : 'text-green-800'}`}>
                                <MdHistory /> {hasPenalty ? 'Missed Inspections' : 'Inspection History'}
                            </h3>
                            <button onClick={() => setShowModal(false)}>
                                <MdClose size={24} className={hasPenalty ? "text-red-400" : "text-green-400"} />
                            </button>
                        </div>

                        <div className="max-h-[60vh] overflow-y-auto p-0">
                            {data.details.length === 0 ? (
                                <div className="p-8 text-center text-gray-400">
                                    No penalty records found. Keep it up!
                                </div>
                            ) : (
                                <table className="w-full text-left border-collapse">
                                    <thead className="bg-gray-50 text-gray-500 text-xs uppercase">
                                        <tr>
                                            <th className="p-4 border-b">Missed Date</th>
                                            <th className="p-4 border-b text-right">Fine</th>
                                            <th className="p-4 border-b text-center">Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.details.map((p, idx) => (
                                            <tr key={idx} className="border-b last:border-0 hover:bg-gray-50">
                                                <td className="p-4 font-bold text-gray-700">
                                                    {new Date(p.missed_date).toLocaleDateString(undefined, { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' })}
                                                </td>
                                                <td className="p-4 text-right text-red-600 font-bold">₹{p.amount}</td>
                                                <td className="p-4 text-center">
                                                    <span className="bg-red-100 text-red-700 text-xs px-2 py-1 rounded-full font-bold">Unpaid</span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>

                        <div className="bg-gray-50 p-4 text-center text-xs text-gray-500">
                            {hasPenalty ? "Penalties are calculated automatically for non-submission." : "Your record is clean. Great job!"}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
